import { render, staticRenderFns } from "./AditionalFieldsDtekItem.vue?vue&type=template&id=07254309&scoped=true"
import script from "./AditionalFieldsDtekItem.vue?vue&type=script&lang=js"
export * from "./AditionalFieldsDtekItem.vue?vue&type=script&lang=js"
import style0 from "./AditionalFieldsDtekItem.vue?vue&type=style&index=0&id=07254309&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07254309",
  null
  
)

export default component.exports